import React, { useState, useEffect } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
} from "reactstrap";
import { Btn } from "../../AbstractElements";
import { toast } from "react-toastify";
import { Eye, EyeOff } from "react-feather";
import { partnerService } from "../../services/partnerService";

const PartnerTokenCard = ({ partnerUuid }) => {
  const [partnerName, setPartnerName] = useState("");
  const [partnerToken, setPartnerToken] = useState("");
  const [tokenLoading, setTokenLoading] = useState(false);
  const [showToken, setShowToken] = useState(false);
  const [partnerDataLoading, setPartnerDataLoading] = useState(false);

  useEffect(() => {
    if (partnerUuid) {
      fetchPartnerData(partnerUuid);
    }
  }, [partnerUuid]);

  const fetchPartnerData = async (uuid) => {
    setPartnerDataLoading(true);
    try {
      const response = await partnerService.getByUuid(uuid, { includeLicenses: false });
      setPartnerName(response.name || "");
      setPartnerToken(response.token || "");
    } catch (error) {
      console.error("Failed to fetch partner data:", error);
    } finally {
      setPartnerDataLoading(false);
    }
  };

  const handleTokenUpdate = async (e) => {
    e.preventDefault();

    if (!partnerToken.trim()) {
      toast.error("Token is required");
      return;
    }

    setTokenLoading(true);
    try {
      await partnerService.updateToken(partnerUuid, { token: partnerToken.trim() });

      toast.success("Partner token updated successfully");
    } catch (error) {
      console.error("Token update failed:", error);
      const message =
        error.response?.data?.message || "Failed to update token";
      toast.error(message);
    } finally {
      setTokenLoading(false);
    }
  };

  if (!partnerUuid) return null;

  return (
    <Col md="12">
      <Card>
        <CardHeader className="pb-0">
          <h5>Partner Token (E2 Cloud)</h5>
        </CardHeader>
        <CardBody>
          {partnerDataLoading ? (
            <div className="text-center py-3">
              <span
                className="spinner-border text-primary"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </span>
            </div>
          ) : (
            <Form onSubmit={handleTokenUpdate}>
              <Row>
                <Col md="4">
                  <FormGroup>
                    <Label>Partner Name</Label>
                    <Input
                      type="text"
                      value={partnerName}
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col md="8">
                  <FormGroup className="position-relative">
                    <Label htmlFor="partnerToken">Token</Label>
                    <div className="d-flex gap-2">
                      <div className="position-relative flex-grow-1">
                        <Input
                          id="partnerToken"
                          type={showToken ? "text" : "password"}
                          value={partnerToken}
                          onChange={(e) =>
                            setPartnerToken(e.target.value)
                          }
                          disabled={tokenLoading}
                          placeholder="Enter E2 Cloud token"
                          required
                        />
                        <div
                          className="show-hide"
                          onClick={() => setShowToken(!showToken)}
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                          }}
                        >
                          {showToken ? (
                            <EyeOff size={16} />
                          ) : (
                            <Eye size={16} />
                          )}
                        </div>
                      </div>
                      <Btn
                        attrBtn={{
                          color: "primary",
                          type: "submit",
                          disabled: tokenLoading,
                          style: { whiteSpace: "nowrap" },
                        }}
                      >
                        {tokenLoading ? "Saving..." : "Update Token"}
                      </Btn>
                    </div>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

export default PartnerTokenCard;
